import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";

const AsignacionesTable = ({
  asignaciones,
  loading,
  activeTab,
  handleRowClick,
}) => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState(null);
  useEffect(() => {
    initFilters();
  }, []);

  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      nombre_producto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue("");
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <>
        <div className="p-col mt-3" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
          <div className="p-input-icon-left" style={{ flex: "1", marginRight: "1rem" }}>
            <i className="pi pi-search" />
            <InputText
              style={{ width: "50%"}}
              value={globalFilterValue ? globalFilterValue.toUpperCase() : ""} 
              onChange={(e) => onGlobalFilterChange(e)}
              placeholder="Buscar Cliente, Producto o Subproducto" 
            />
          </div>
          <h6 className="p-input-icon-left m-0" style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
            {asignaciones?.length} asignaciones
          </h6>
        </div>
      </>
    );
  };
  
  const header = renderHeader();
  
  return (
    <div className="col-12">
        <h5>
          {(() => {
            switch (activeTab) {
              case "Históricas":
                return "Asignaciones Históricas";
              case "Vigentes":
                return "Asignaciones Vigentes";
              case "Futuras":
                return "Asignaciones Futuras";
              case "Proximos Vencimientos":
                return "Próximos Vencimientos";
              case "Sin contrato":
                return "Asignaciones Sin Contrato";
              case "Renovadas":
                return "Asignaciones Renovadas";
              case "No renovadas":
                return "Asignaciones No Renovadas";
              case "Renegociación":
                return "Asignaciones en Renegociación";
              case "Deuda":
                return "Asignaciones con Deuda";
              default:
                return "Todas las Asignaciones";
            }
          })()}
        </h5>
        <DataTable
          value={asignaciones?.map(a => ({
            ...a,
            _searchableText: [a.cliente?.razonSocial, ...(a.arriendos || [])].join(" ").toUpperCase(),
            _productosText: (a.arriendos || []).join(", ")
          }))}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50, 100,500]}
          dataKey="id"
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          emptyMessage="No se encontraron asignaciones."
          rowClassName={(rowData) => {
            const alertas = rowData?.alertas;
            if (Array.isArray(alertas) && alertas.length > 0) {
              const color = alertas[0]?.["background-color"];
              if (typeof color === "string" && color.trim() !== "") {
                const cssClass = color.startsWith("bg-") ? color : `bg-${color}`;
                return `row-clickable ${cssClass}`;
              }
            }
            return "row-clickable";
          }}
          className="p-datatable-gridlines "
          onRowClick={(e) => !loading && handleRowClick(e.data)}
          header={header}
          globalFilterFields={["cliente.razonSocial", "_searchableText"]}
          stripedRows="true"
          showGridlines
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} asignaciones"
          reorderableColumns
        >
          <Column
            field="id"
            header="Asignación"
            style={{ width: "10%" }}
            body={(rowData) => (
              <span>
                {rowData.folio ? (
                  <><strong>Folio</strong> {rowData.folio} <br/>
                  <strong>ID</strong> {rowData.id}</>
                ) : (
                  <><strong>ID</strong> {rowData.id}</>
                )}
              </span>
            )}
            sortable 
            sortField="id"
          />
          
          <Column
            field="cliente.alias"
            header="Cliente Alias"
            style={{ width: "8%" }}
            body={(rowData) => rowData.cliente.alias}
            sortable
          />

          <Column
            field="fecha_creacion_asignacion"
            header="Fecha de Asignación"
            style={{ width: "10%", textAlign:"center"}}
            body={(rowData) => {
              if (rowData.contrato && rowData.contrato.fecha_creacion_contrato) {
                let date;
                if (typeof rowData.contrato.fecha_creacion_contrato === 'string') {
                  const parts = rowData.contrato.fecha_creacion_contrato.split(' ');
                  if (parts.length === 6) {
                    const [, month, day, time, , year] = parts;
                    date = new Date(`${month} ${day} ${year} ${time} GMT-0400`);
                  } else {
                    date = new Date(rowData.contrato.fecha_creacion_contrato);
                  }
                } else {
                  date = new Date(rowData.contrato.fecha_creacion_contrato);
                }
                if (isNaN(date)) {
                  return "Fecha inválida";
                }
                return date.toLocaleDateString('es-CL', {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }).replace(/-/g, '/');
              }
              return "Sin Fecha";
            }}
            sortable
          />

          <Column
            field="desde"
            header="Desde"
            style={{ width: "8%" }}
            body={(rowData) => rowData.desde || "Sin Fecha"}
            sortable
          /> 

          <Column
            field="hasta"
            header="Hasta"
            style={{ width: "8%" }}
            body={(rowData) => rowData.hasta || "Sin Fecha"}
            sortable
          />
          <Column
            field="_productosText"
            header="Productos"
            style={{ width: "18%" }}
            body={(rowData) => rowData.arriendos?.join(", ") || "-"}
            sortable
          />
          <Column
            field="empresa"
            header="Empresa"
            filterMenuStyle={{ width: "14rem" }}
            style={{ width: "13%" }}
            body={(rowData) => rowData.empresa}
            sortable
            sortField="empresa"
          />
          <Column
            field="aviso"
            header="Días Aviso"
            style={{ width: "7%" }}
            body={(rowData) => rowData.aviso}
            sortable
            sortField="aviso"
          />
          <Column
            field="asignadorNombre"
            header="Responsable"
            style={{ width: "10%" }}
            body={(rowData) => rowData.asignadorNombre}
            sortable
            sortField="asignadorNombre"
          />
        </DataTable>
    </div>
  );
};

export default AsignacionesTable;
